import * as yup from 'yup';
import { AlunoModelValidator } from '../Aluno';
import { DepositoModelValidator } from '../Deposito';
import { IValidator } from '../IValidator';
import { MonografiaModel, PalavrasChave } from './Model';

const monografiaSchema = yup.object().shape<MonografiaModel>({
  id: yup.number(),
  titulo: yup.string().max(200),
  bibliografia: yup.string(),
  desenvolvimento: yup.string(),
  justificativa: yup.string().min(200),
  deposito: DepositoModelValidator.schema,
  aluno: AlunoModelValidator.schema,
  dataDeApresentacaoSugerida: yup.date(),
  banca: yup.object(),
  professor: yup.object(),
  palavrasChave: yup.array<PalavrasChave>()
});

export const MonografiaModelValidator = new IValidator<{palavrasChave: Array<PalavrasChave>,titulo: string}>(monografiaSchema);